import { useQuery } from '@tanstack/react-query';
import { fetchDocumentMetadata } from '@services/documentService';
import { DocumentType } from '@common/types';
import { IDocumentMetadataDto } from '@common/features/document/types';

export const queryKey = 'fetchDocumentMetadata';

export const useFetchDocumentMetadata = (
  documentId?: number,
  version?: number,
  documentType?: DocumentType,
) => {
  const { data, isFetching, refetch } = useQuery<IDocumentMetadataDto>(
    [queryKey, documentId, version, documentType],
    () => fetchDocumentMetadata(documentId!, version!, documentType!),
    {
      enabled: !!documentId && !!version && !!documentType,
    },
  );

  return {
    documentMetadata: data,
    isFetchingDocumentMetadata: isFetching,
    refetchDocumentMetadata: refetch,
  };
};
